import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "ct_cookie_consent_v1";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      if (!v) setShow(true);
    } catch {
      setShow(true);
    }
  }, []);

  const setChoice = (choice) => {
    try {
      localStorage.setItem(
        KEY,
        JSON.stringify({ choice, ts: new Date().toISOString() })
      );
    } catch {}
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      role="dialog"
      aria-live="polite"
      data-testid="cookie-consent"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-2xl border border-slate-200 bg-white/95 p-4 shadow-2xl backdrop-blur md:p-5"
    >
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="pr-2 text-sm leading-relaxed text-slate-600">
          We use cookies to enhance your browsing experience and support our services.
          By continuing, you consent to our{" "}
          <Link
            to="/privacy"
            className="font-semibold text-neutral-700 underline-offset-4 hover:underline"
          >
            Privacy Policy
          </Link>
          . Users under 18 require parental consent. Aligned with the DPDP Act, 2023.
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <button
            onClick={() => setChoice("declined")}
            data-testid="cookie-decline"
            className="rounded-full px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100"
          >
            Decline
          </button>
          <button
            onClick={() => setChoice("accepted")}
            data-testid="cookie-accept"
            className="rounded-full bg-[#0A0A0A] px-4 py-2 text-sm font-semibold text-white hover:bg-[#262626]"
          >
            Accept
          </button>
          <button
            onClick={() => setChoice("dismissed")}
            aria-label="Close"
            data-testid="cookie-close"
            className="rounded-full p-2 text-slate-400 hover:bg-slate-100"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
